import script from "./PageThree.vue?vue&type=script&setup=true&lang=js"
export * from "./PageThree.vue?vue&type=script&setup=true&lang=js"

import "./PageThree.vue?vue&type=style&index=0&id=9b565bd0&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/qc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b565bd0"]])

export default __exports__